export const getSelectedLogoUrl = (client, reveal) => {
  if (client !== "delta") return undefined;
  const folder = reveal?.logo?.folder;
  const image = reveal?.logo?.image;
  if (!folder || !image) return undefined;
  return `/brand-assets/Delta/${folder}/${image}`;
};
